export const formValues = {
  Title: 'Evento CCE',
  PosterURL: "https://hoppia.s3-us-west-2.amazonaws.com/events/2020/09/event_hoppia.jpg",
  Text: 'Sin texto',
  Date: "2020-09-03T18:00",
  URL: 'https://hoppia.s3-us-west-2.amazonaws.com/events/2020/09/event_hoppia.jpg',
  Show: false,
}